// extracted by mini-css-extract-plugin
export default {"customInput":"styles_customInput__frwZp","label":"styles_label__-Mytw","input":"styles_input__YWVu0","textarea":"styles_textarea__6P0oQ"};